/* This file is autogenerated, see readme.md for instructions */
import TemplateSvgIcon from '@bloomreach/banana-theme/icons/template.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TemplateIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TemplateSvgIcon />
    </Icon>
  );
});

TemplateIcon.displayName = 'TemplateIcon';

export default TemplateIcon;
